import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ErrorFilled } from '@one-thd/sui-icons';
import '../../styles/business-tools.scss';
export var BusinessToolsErrorMessage = function () {
    return (React.createElement("div", { className: "sui-flex sui-text-danger business-tools__marginTop" },
        React.createElement("div", { className: "sui-self-center", style: { paddingRight: 5 } },
            React.createElement(ErrorFilled, { color: "danger" })),
        React.createElement(Typography, { variant: "body-lg" }, " "),
        React.createElement(Typography, { variant: "body-base" },
            React.createElement("span", { className: "" }, "We're Sorry!"),
            "There was a temporary technical error displaying this information. Please try refreshing the page.")));
};
